import Vue from 'vue'
import Vuex from 'vuex'
import _ from "lodash"
import getControllers from '../gql/getController.gql'
Vue.use(Vuex)
export default {
    namespaced: true,
    state: {
        intellModel:[],// 诊断影像模块使用权限 'edit_DTT1', 'edit_PFJ1', 'edit_CT', 'edit_BC', 'edit_BL'
        auths:['diagnoses_image'],// 功能权限 // inhospital_order 住院 homeInfo diagnoses_image 影像诊断  operation_order 手术预约
        editDuration:7*24*3600*1000,// 编辑时长 小时/单位
        hasLogin:false, // 是否已地登录
    },
    mutations:{
        setintellModel(state,n){
            state.intellModel=n;
        },
        setauths(state,n){
            state.auths=n;
        },
        setAllowAiSearch(state,n){
           state.allowAiSearch=n;
        },
        seteditDuration(state,n){
            state.editDuration=n;
        },
        sethasLogin(state,n){
            state.hasLogin=n;
        },
    },
    actions: {
        async getController({dispatch,commit,state},that){ // await this.$store.dispatch('controller/getController');
            if(_.isEmpty(state.intellModel)){
                let res = await that.defaultClient.query({
                    query:getControllers,
                    fetchPolicy: 'no-cache',
                  });
                let newRes = res.data.me;
                // let newRes = {
                //     image_modality:[{
                //         modality_name:"大体图"
                //     },
                //     {
                //         modality_name:"皮肤镜"
                //     },
                //     {
                //         modality_name:"皮肤CT"
                //     },
                //     {
                //         modality_name:"皮肤B超"
                //     },
                //     {
                //         modality_name:"病理"
                //     },
                // ]
                // }
                let authsArray =['diagnoses_image'];
                let intellModelArray =[];
                if(newRes.advanced_function){
                    
                    for(let i =0;i<newRes.advanced_function.length;i++) {
                        if(newRes.advanced_function[i].module_name ==='手术'){
                            authsArray.push('operation_order')
                        }
                        if(newRes.advanced_function[i].module_name ==='住院'){
                            authsArray.push('inhospital_order')
                        }
                        if(newRes.advanced_function[i].module_name ==='导出'){
                            authsArray.push('export_hostory')
                        }
                        if(newRes.advanced_function[i].module_name ==='美容/光疗'){
                            authsArray.push('export_cosmetology')
                        }
                        if(newRes.advanced_function[i].module_name ==='添加治疗项目'){
                            authsArray.push('export_AddMethods')
                        }
                        if(newRes.advanced_function[i].module_name ==='手术量编辑'){
                          authsArray.push('surgery_appointment')
                        }
                        if(newRes.advanced_function[i].module_name ==='预约登记数量编辑'){
                          authsArray.push('cosmet_registration')
                        }
                        if(newRes.advanced_function[i].module_name ==='生成云胶片'){
                            authsArray.push('gen_online_report')
                        }
                        // 增加白癜风专病
                        if(newRes.advanced_function[i].module_name ==='白癜风专病'){
                            authsArray.push('sd_vitiligo')
                        }
                        // 增加黑色素瘤专病
                        if(newRes.advanced_function[i].module_name ==='黑色素瘤专病'){
                            authsArray.push('sd_mm')
                        }
                        // 增加科研队列
                        if(newRes.advanced_function[i].module_name ==='科研队列'){
                            authsArray.push('cohort')
                        }
                        // 显示附加诊断结果（XJ）
                        if(newRes.advanced_function[i].module_name ==='附加诊断结果'){
                            authsArray.push('show_append_conclusion')
                        }
                    }
                    //console.log("Get newRes.advanced_function:",newRes.advanced_function);
                    //console.log("Get authsArray:",authsArray);
                }
                if(newRes.image_modality){
                    
                    for(let i =0;i<newRes.image_modality.length;i++) {
                        if(newRes.image_modality[i].modality_name ==='大体图'){
                            intellModelArray.push('edit_DTT')
                        }
                        if(newRes.image_modality[i].modality_name ==='皮肤镜'){
                            intellModelArray.push('edit_PFJ')
                        }
                        if(newRes.image_modality[i].modality_name ==='皮肤CT'){
                            intellModelArray.push('edit_CT')
                        }
                        if(newRes.image_modality[i].modality_name ==='皮肤B超'){
                            intellModelArray.push('edit_BC')
                        }
                        if(newRes.image_modality[i].modality_name ==='病理'){
                            intellModelArray.push('edit_BL')
                        }
                    }
                }
                
                if(newRes.allow_modify_time) {
                    commit('seteditDuration',Number(newRes.allow_modify_time)*60*1000)
                }
                commit('setAllowAiSearch',newRes.allow_ai_search)
                commit('setauths',authsArray)
                commit('setintellModel',intellModelArray)
            }
        }
    }
}
